<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="main-event-wrapper" v-if="eventList.length > 0">
    <agile :dots="false" ref="eventCarousel" :unagile="eventList.length === 1">
      <div class="slide" v-for="(event, index) in eventList"
           :key="index"
           @click="moveToDetail(event)"
      >
        <!--<img alt="배너 이미지"/>-->
        <div :style="{'background-image': 'url(' + event.image_url + ')'}" class="background-event"></div>
      </div>
      <!--<div class="slide" @click="moveToDetail({-->
      <!--target_url: '/detail/2784'-->
      <!--})">-->
      <!--&lt;!&ndash;<img alt="배너 이미지"/>&ndash;&gt;-->
      <!--<div :style="{'background-image': 'url(' + ExampleImage + ')'}" class="background-event"></div>-->
      <!--</div>-->
      <template slot="prevButton">
        <img src="../../assets/images/prev.png" />
      </template>
      <template slot="nextButton">
        <img src="../../assets/images/next.png" />
      </template>
    </agile>
    <ul v-if="eventList.length > 1">
      <li v-for="(event, index) in eventList"
          :key="index"
          :class="{on: index === $refs.eventCarousel && $refs.eventCarousel.getCurrentSlide()}"
          @click="$refs.carousel.goTo(index)"
      >
      </li>
    </ul>
  </div>
</template>

<script>
  import {VueAgile} from 'vue-agile'
  import DynamicNavigator from '../../core/modules/DynamicNavigator'
  export default {
    name: 'EventBanner',
    components: {
      agile: VueAgile
    },
    data () {
      return {
        eventList: []
      }
    },
    methods: {
      async fetchEventList () {
        try {
          const eventList = await this.axios.get('/events')
          this.eventList = eventList.data.result
          console.log(this.eventList)
        } catch (error) {
          console.error(error)
        }
      },
      moveToDetail (event) {
        if (event.target_url.indexOf('http') > -1 || event.target_url.indexOf('https') > -1) {
          window.open(event.target_url, '_blank')
        } else {
          let routeData = this.$router.resolve(event.target_url)
          DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
        }
      }
    },
    mounted () {
      this.fetchEventList()
    }
  }
</script>

<style scoped lang="less">
  .main-event-wrapper {
    flex: 1;
    position: relative;
    max-height: 20rem;
    padding-top: 3rem;

    .slide {
      position: relative;
      cursor: pointer;
      .background-event {
        height: 20rem;
        // background-size: cover;
        background-size : contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }

    .custom-dot {
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 1.5rem;
      width: 100%;

      li {
        width: 1rem;
        height: 1rem;
        background:url('../../assets/images/indi.png') no-repeat no-repeat;
        cursor: pointer;
        &.on {
          background:url('../../assets/images/indi-on.png') no-repeat no-repeat;
        }
      }
    }
  }
</style>
<style lang="less">
  .main-event-wrapper {
    .agile__actions {
      top: 50%;
      position: absolute;
      transform: translate(0, -50%);
      width: 100%;
      > button {
        background: transparent;
        &.agile__nav-button--next {
          padding-right: 2rem;
        }

        &.agile__nav-button--prev {
          padding-left: 2rem;
        }
      }
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */

  @media screen and (max-width: 1366px) {
    .main-event-wrapper {
      padding-top: 3.2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .main-event-wrapper {
      max-height: 12rem;
      padding-top: 0;
      .slide {
        .background-event {
          height: 12rem;
        }
      }
    }
  }
</style>

